import 'views/assets/customBootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueResource from 'vue-resource';

// Register plugins
Vue.use(BootstrapVue);
Vue.use(VueResource);

// Expose Vue globally
window.Vue = Vue;
